var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProyecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235.781,
    height: 235.781,
    viewBox: "0 0 235.781 235.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #418c5a;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    className: "cls-1",
    width: 235.781,
    height: 235.781,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Etapas",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    className: "cls-3",
    d: "M99.549,99.548V12.111A12.117,12.117,0,0,1,111.665-.006h112a12.117,12.117,0,0,1,12.116,12.117V223.665a12.117,12.117,0,0,1-12.116,12.117H12.117A12.117,12.117,0,0,1,0,223.666v-112A12.116,12.116,0,0,1,12.117,99.548Zm11.789,124.445H223.665a.326.326,0,0,0,.327-.328V12.11a.327.327,0,0,0-.327-.328h-112a.328.328,0,0,0-.328.328V223.993ZM99.549,111.337H12.117a.327.327,0,0,0-.328.328v112a.327.327,0,0,0,.328.327H99.549Z",
    transform: "translate(0 0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    className: "cls-3",
    d: "M302.012,319.977A12.117,12.117,0,0,0,289.9,307.86H265.008a12.117,12.117,0,0,0-12.117,12.116v43.558a5.894,5.894,0,0,0,5.894,5.894h37.332a5.894,5.894,0,0,0,5.9-5.894Zm-11.789,0a.327.327,0,0,0-.327-.327H265.008a.328.328,0,0,0-.328.327V357.64h25.543Z",
    transform: "translate(-109.786 -133.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    className: "cls-3",
    d: "M344.541,56.095a12.116,12.116,0,0,0-12.117-12.116H319.981a12.117,12.117,0,0,0-12.117,12.116V68.541a12.117,12.117,0,0,0,12.117,12.117h12.443a12.116,12.116,0,0,0,12.117-12.117Zm-11.789,0a.327.327,0,0,0-.328-.328H319.981a.329.329,0,0,0-.328.328V68.541a.328.328,0,0,0,.328.327h12.443a.326.326,0,0,0,.328-.327V56.1Z",
    transform: "translate(-133.652 -19.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    className: "cls-3",
    d: "M256.578,56.095a12.117,12.117,0,0,0-12.117-12.116H232.018A12.117,12.117,0,0,0,219.9,56.095V68.541a12.117,12.117,0,0,0,12.117,12.117h12.444a12.117,12.117,0,0,0,12.116-12.117Zm-11.789,0a.328.328,0,0,0-.328-.328H232.017a.327.327,0,0,0-.327.328V68.541a.326.326,0,0,0,.328.327h12.444a.327.327,0,0,0,.328-.327V56.1Z",
    transform: "translate(-95.465 -19.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    className: "cls-3",
    d: "M256.578,144.058a12.118,12.118,0,0,0-12.117-12.117H232.018A12.118,12.118,0,0,0,219.9,144.058V156.5a12.117,12.117,0,0,0,12.117,12.117h12.444A12.117,12.117,0,0,0,256.578,156.5Zm-11.789,0V156.5a.329.329,0,0,1-.328.328H232.018a.328.328,0,0,1-.328-.328V144.058a.327.327,0,0,1,.327-.328h12.444a.328.328,0,0,1,.328.328Z",
    transform: "translate(-95.465 -57.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    className: "cls-3",
    d: "M344.541,144.058a12.116,12.116,0,0,0-12.116-12.117H319.98a12.117,12.117,0,0,0-12.116,12.117V156.5a12.116,12.116,0,0,0,12.117,12.117h12.443A12.115,12.115,0,0,0,344.541,156.5Zm-11.789,0V156.5a.328.328,0,0,1-.328.328H319.98a.329.329,0,0,1-.328-.328V144.058a.328.328,0,0,1,.328-.328h12.444a.327.327,0,0,1,.328.328Z",
    transform: "translate(-133.652 -57.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    className: "cls-3",
    d: "M256.578,232.023a12.117,12.117,0,0,0-12.117-12.116H232.018A12.117,12.117,0,0,0,219.9,232.023v12.443a12.116,12.116,0,0,0,12.117,12.116h12.444a12.116,12.116,0,0,0,12.116-12.116Zm-11.789,0a.328.328,0,0,0-.328-.327H232.017a.327.327,0,0,0-.327.327v12.443a.326.326,0,0,0,.328.327h12.444a.327.327,0,0,0,.328-.327Z",
    transform: "translate(-95.465 -95.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    className: "cls-3",
    d: "M344.541,232.021A12.115,12.115,0,0,0,332.424,219.9H319.98a12.116,12.116,0,0,0-12.116,12.117v12.443a12.117,12.117,0,0,0,12.117,12.117h12.443a12.117,12.117,0,0,0,12.116-12.117Zm-11.789,0v12.444a.327.327,0,0,1-.328.328H319.98a.328.328,0,0,1-.328-.327V232.02a.329.329,0,0,1,.328-.328h12.444a.328.328,0,0,1,.328.328Z",
    transform: "translate(-133.652 -95.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    className: "cls-3",
    d: "M105.541,232.021A12.117,12.117,0,0,0,93.424,219.9H56.092a12.118,12.118,0,0,0-12.116,12.117v12.443a12.117,12.117,0,0,0,12.117,12.117H93.424a12.116,12.116,0,0,0,12.116-12.117Zm-11.789,0v12.444a.327.327,0,0,1-.328.328H56.092a.326.326,0,0,1-.327-.327V232.02a.328.328,0,0,1,.327-.328H93.424a.329.329,0,0,1,.328.328Z",
    transform: "translate(-19.091 -95.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    className: "cls-3",
    d: "M105.543,319.983a12.116,12.116,0,0,0-12.117-12.116H56.093a12.116,12.116,0,0,0-12.117,12.116v12.444a12.116,12.116,0,0,0,12.117,12.117H93.426a12.116,12.116,0,0,0,12.117-12.117Zm-11.789,0v12.444a.329.329,0,0,1-.328.328H56.093a.328.328,0,0,1-.327-.328V319.983a.327.327,0,0,1,.327-.328H93.426a.328.328,0,0,1,.328.328Z",
    transform: "translate(-19.091 -133.653)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyecto);
export default __webpack_public_path__ + "static/media/Proyecto.878db312ed80cfc4c7e1e5298454d70a.svg";
export { ForwardRef as ReactComponent };